/**
 * Where a reservation was created. Stamped once at creation and never changed, so documents
 * written before the field existed carry no value at all.
 */
export var ReservationSource;
(function (ReservationSource) {
    ReservationSource["BOOKING_ENGINE"] = "BOOKING_ENGINE";
    ReservationSource["GUEST_APP"] = "GUEST_APP";
    ReservationSource["DASHBOARD"] = "DASHBOARD";
    ReservationSource["PMS"] = "PMS";
    ReservationSource["SYSTEM"] = "SYSTEM";
})(ReservationSource || (ReservationSource = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["PENDING"] = "PENDING";
    ReservationStatus["CONFIRMED"] = "CONFIRMED";
    ReservationStatus["ACTIVE"] = "ACTIVE";
    ReservationStatus["COMPLETED"] = "COMPLETED";
    ReservationStatus["CANCELLED"] = "CANCELLED";
    ReservationStatus["NO_SHOW"] = "NO_SHOW";
    ReservationStatus["OPTION"] = "OPTION";
    ReservationStatus["UNCOMPLETED"] = "UNCOMPLETED";
})(ReservationStatus || (ReservationStatus = {}));
export var RepeatRule;
(function (RepeatRule) {
    RepeatRule["CUSTOM"] = "CUSTOM";
    RepeatRule["EVERY_DAY"] = "EVERY_DAY";
    //  Hiding others as suggested by product
    // EVERY_SECOND_DAY = 'EVERY_SECOND_DAY',
    // EVERY_WEEK = 'EVERY_WEEK',
    // EVERY_2_WEEKS = 'EVERY_2_WEEKS',
    // EVERY_3_WEEKS = 'EVERY_3_WEEKS',
    // EVERY_4_WEEKS = 'EVERY_4_WEEKS',
    // EVERY_5_WEEKS = 'EVERY_5_WEEKS',
    // EVERY_6_WEEKS = 'EVERY_6_WEEKS',
    // EVERY_7_WEEKS = 'EVERY_7_WEEKS',
    // EVERY_8_WEEKS = 'EVERY_8_WEEKS',
    // EVERY_MONTH = 'EVERY_MONTH',
    // EVERY_6_MONTHS = 'EVERY_6_MONTHS',
    // EVERY_YEAR = 'EVERY_YEAR',
    // EVERY_WEEKDAY = 'EVERY_WEEKDAY',
    // EVERY_WEEKEND = 'EVERY_WEEKEND',
    // EVERY_MONTH_SAME_FIRST_WEEKDAY = 'EVERY_MONTH_SAME_FIRST_WEEKDAY',
    // EVERY_MONTH_SAME_LAST_WEEKDAY = 'EVERY_MONTH_SAME_LAST_WEEKDAY'
})(RepeatRule || (RepeatRule = {}));
export var SlotType;
(function (SlotType) {
    SlotType["RESERVATION"] = "RESERVATION";
    SlotType["SERIAL"] = "SERIAL";
    SlotType["BLOCK"] = "BLOCK";
})(SlotType || (SlotType = {}));
export var getPermittedSlotTypesPerResourceCategoryFilter = function (resourceCategoryFilter) {
    if (!resourceCategoryFilter) {
        return [SlotType.RESERVATION, SlotType.BLOCK];
    }
    switch (resourceCategoryFilter) {
        case 'resources':
            return [SlotType.RESERVATION, SlotType.BLOCK];
        case 'services':
            return [SlotType.RESERVATION];
        default:
            return [SlotType.RESERVATION, SlotType.BLOCK];
    }
};
export var TableReservationEvent;
(function (TableReservationEvent) {
    TableReservationEvent["BIRTHDAY"] = "BIRTHDAY";
    TableReservationEvent["ENGAGEMENT"] = "ENGAGEMENT";
    TableReservationEvent["WEDDING_CEREMONY"] = "WEDDING_CEREMONY";
    TableReservationEvent["WEDDING_ANNIVERSARY"] = "WEDDING_ANNIVERSARY";
    TableReservationEvent["FAMILY_EVENT"] = "FAMILY_EVENT";
    TableReservationEvent["CELEBRATION"] = "CELEBRATION";
    TableReservationEvent["EDUCATION"] = "EDUCATION";
    TableReservationEvent["PROMOTION"] = "PROMOTION";
    TableReservationEvent["COMMEMORATION"] = "COMMEMORATION";
    TableReservationEvent["OTHER"] = "OTHER";
})(TableReservationEvent || (TableReservationEvent = {}));
